import {AminoConverter} from "@shareledgerjs/amino";

export function createAuthzAminoConverters(): Record<string, AminoConverter | "not_supported_by_chain"> {
  return {};
}
